import { defineStore } from 'pinia';
import { signatureGenerate, getGenerateResult } from '@/api/myaha';


export const useStore = defineStore('default', {
  persist: {
    key: 'ap-store',
    storage: localStorage
  },
  state: () => ({
    fingerprint: '',
    prompt: "",
    model: 'flux_schnell', //flux_pro|flux_schnell
    example: "music",
    resultUrl: "",
    loading: false
  }),
  getters: {
    isChecked: (state) => {
      return (app) => state.socialApps.includes(app)
    }
  },
  actions: {
    init() {
      this.prompt = `Handwritten signature of "Tom Cruise" in an elegant, flowing cursive font, surrounded by musical notes and small instruments like a guitar or piano. The notes and instruments are carefully integrated into the design, adding a sense of rhythm and harmony. The overall composition conveys a lively, artistic feel. White background, black font.`
      this.resultUrl = ""
      this.loading = false
    },
    setFingerprint(value) {
      this.fingerprint = value;
    },
    setModel(value) {
      this.model = value;
    },
    setPrompt(value) {
      this.prompt = value;
    },
    generate() {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        this.resultUrl = ""
        let res = await signatureGenerate(this.fingerprint, { prompt: this.prompt, model: this.model })
        if (res.code === 300103) {
          // commit('setVisibleLimitDialog', true)
          return
        }
        let task_id = res.result?.task_id
        // console.log('generateImage', task_id)
        if (task_id) {
          let num = 0;
          let numtimer = setInterval(() => { num++; }, 1000)
          return new Promise((resolve, reject) => {
            getGenerateResult(this.fingerprint, task_id, this.model, 3000, 5 * 60 * 1000, (error, result_url) => {
              if (result_url) {
                this.resultUrl = result_url
                // commit('setGeneratedImageUrl', result_url)
                // commit('setCredits', state.credits - 1 > 0 ? state.credits - 1 : 0)
                clearInterval(numtimer);
                console.log('生成了多长时间', num);
                resolve({ num });
              } else {
                reject(error);
              }
              this.loading = false
            }
            )
          })
        } else {
          return reject('No task_id found');
        }
      });
    },
    setEaxmple(value) {
      let data = {
        "music": `Handwritten signature of "Tom Cruise" in an elegant, flowing cursive font, surrounded by musical notes and small instruments like a guitar or piano. The notes and instruments are carefully integrated into the design, adding a sense of rhythm and harmony. The overall composition conveys a lively, artistic feel. White background, black font.`,
        "bird": `"Tom Cruise" is elegantly written in a flowing cursive font, with a softly outlined bird hovering near the right corner. Its wings are spread wide, creating a sense of graceful movement. The bird and the text blend seamlessly, evoking an atmosphere of freedom, beauty, and effortless elegance on a clean white background, with the text in a classic black tone.`,
        "butterfly": `the name "Tom Curise" is written in elegant, cursive script.To the right of the name, there is a small butterfly.The butterfly's wings are extended.The butterfly is positioned slightly above the "Tom Curise" text, adding a touch of whimsy and personality to the design.white background.black font.`,
        "cat": `create an artistic signature for the name "Carman", with a minimalist and cartoonish style. Above the name, depict a cat with a simple, round head and large, almond-shaped eyes. The cat's features should include a small, triangular nose and delicate whiskers. The body of the cat should be represented as a smooth, flowing curved line that extends into a playful tail, seamlessly merging into the letters of "Carman". The text should be in an elegant, cursive black font, matching the cat's outline.white background.`,
        "flower": `the name "Tom Cruise" written in elegant, cursive black script. The text is centered on a plain white background. Flanking the name on both sides are delicate, hand-drawn floral arrangements. The flowers are a soft pink with yellow centers, and they are accompanied by small green leaves. The flowers are positioned in a way that they appear to be floating around the name, giving a sense of natural beauty and elegance.`,
        "star": `a creative signature for "Carman" with fluid, elegant strokes. with small stars scattered around the name in two colors black and gold. emphasizing the beauty of both the signature and the star elements.white background.black font.`,
      }
      this.prompt = data[value];
      this.example = value
    },
  },
});
